<form novalidate #setupForm="ngForm" class="form">
  <div class="title-container">
    <div class="title">Stream type settings</div>
    <div><i class="mdi mdi-close close" (click)="onClickCancel()"></i></div>
  </div>
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label">
        <div>Service</div>
        <div class="unit-label vert-text-mid">Select emulated service type.</div>
      </div>
      <div class="section-data">
        <div class="group">
          <div class="label">Stream Type</div>
          <mat-select
            class="option-list width-150"
            #streamTypeInput="ngModel"
            [(ngModel)]="formField.streamType"
            name="streamType"
            (selectionChange)="onstreamTypeChange()"
            required
          >
            <mat-option *ngFor="let item of streamTypeSelection" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">
        <div>Layer 2</div>
        <div class="unit-label vert-text-mid">Set layer 2 test parameters.</div>
      </div>
      <div class="section-data">
        <div class="group">
          <div class="label">Frame Size</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-150 float-left"
            [ngClass]="{
              'input-disabled': formField.streamType === 'Voice'
            }"
            [disabled]="formField.streamType === 'Voice'"
            name="frameSize"
            #frameSizeInput="ngModel"
            [(ngModel)]="formField.frameSize"
            (ngModelChange)="onChangeFrameSize()"
            (click)="onChangeFrameSize()"
          />
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">
        <div>SLA</div>
        <div class="unit-label vert-text-mid">
          Set service level agreements for this stream. Enter CIR as L2 IR.
        </div>
      </div>
      <div class="section-data direction-column">
        <div class="section-data">
          <div
            class="section-data-container"
            *ngIf="direction !== 'unidirectional-b2a' && data?.tableChange === 'tableA'"
          >
            <div>A<i class="mdi mdi-arrow-right-bold"></i>B</div>
            <div class="group-container">
              <div class="group">
                <div class="label">{{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} IR</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-data width-75 float-left"
                  name="l2IrA2B"
                  #l2IrA2BInput="ngModel"
                  [(ngModel)]="formField.l2IrA2B"
                  (focusout)="onL2IrA2BChange()"
                  [min]="minL2IrA2B"
                  [max]="maxL2IrA2B"
                  required
                />
                <span class="unit-label vert-text-mid">Mbps</span>
                <div
                  class="error clr-float"
                  *ngIf="l2IrA2BInput.invalid && (l2IrA2BInput.dirty || l2IrA2BInput.touched)"
                >
                  <mat-error *ngIf="l2IrA2BInput.errors?.required"> Field is required</mat-error>
                  <mat-error *ngIf="l2IrA2BInput.errors?.min || l2IrA2BInput.errors?.max"
                    >Valid range is a number between {{ minL2IrA2B }} to {{ maxL2IrA2B }}</mat-error
                  >
                </div>
                <mat-error *ngIf="isL2IrA2B"
                  >Input causes derived
                  {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} bandwidth:
                  {{ derivedL2IrA2B }} Mbps to exceed max configured bandwidth {{ maxBandWidth }}
                </mat-error>
              </div>
              <div class="group">
                <div class="label">UDP BW</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-data width-75 float-left"
                  name="udpBwA2B"
                  #udpBwA2BInput="ngModel"
                  [(ngModel)]="formField.udpBwA2B"
                  (focusout)="onUdpBwA2BChange()"
                  required
                />
                <span class="unit-label vert-text-mid">Mbps</span>
                <div
                  class="error clr-float"
                  *ngIf="udpBwA2BInput.invalid && (udpBwA2BInput.dirty || udpBwA2BInput.touched)"
                >
                  <mat-error *ngIf="udpBwA2BInput.errors?.required"> Field is required</mat-error>
                </div>
                <mat-error *ngIf="isL1ULRBandwidthMaxA2B"
                  >Input causes derived
                  {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} bandwidth:
                  {{ derivedL1UdpBwA2B }} Mbps to exceed max configured bandwidth {{ maxBandWidth }}
                </mat-error>
              </div>
            </div>
          </div>
          <div class="section-data-container" *ngIf="data?.tableChange === 'tableB'">
            <div>B <i class="mdi mdi-arrow-right-bold"></i> A</div>
            <div class="group-container">
              <div class="group">
                <div class="label">{{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} IR</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-data width-75 float-left"
                  name="l2IrB2A"
                  #l2IrB2AInput="ngModel"
                  [(ngModel)]="formField.l2IrB2A"
                  (focusout)="onL2IrB2AChange()"
                  [min]="minL2IrA2B"
                  [max]="maxL2IrA2B"
                  required
                />
                <span class="unit-label vert-text-mid">Mbps</span>
                <div
                  class="error clr-float"
                  *ngIf="l2IrB2AInput.invalid && (l2IrB2AInput.dirty || l2IrB2AInput.touched)"
                >
                  <mat-error *ngIf="l2IrB2AInput.errors?.required"> Field is required</mat-error>
                  <mat-error *ngIf="l2IrB2AInput.errors?.min || l2IrB2AInput.errors?.max"
                    >Valid range is a number between {{ minL2IrA2B }} to {{ maxL2IrA2B }}</mat-error
                  >
                </div>
                <mat-error *ngIf="isL2IrB2A"
                  >Input causes derived
                  {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} bandwidth:
                  {{ derivedL2IrB2A }} Mbps to exceed max configured bandwidth {{ maxBandWidth }}
                </mat-error>
              </div>
              <div class="group">
                <div class="label">UDP BW</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-data width-75 float-left"
                  name="udpBwB2A"
                  #udpBwB2AInput="ngModel"
                  [(ngModel)]="formField.udpBwB2A"
                  (focusout)="onUdpBwB2AChange()"
                  required
                />
                <span class="unit-label vert-text-mid">Mbps</span>
                <div
                  class="error clr-float"
                  *ngIf="udpBwB2AInput.invalid && (udpBwB2AInput.dirty || udpBwB2AInput.touched)"
                >
                  <mat-error *ngIf="udpBwB2AInput.errors?.required"> Field is required</mat-error>
                </div>
                <mat-error *ngIf="isL1ULRBandwidthMaxB2A"
                  >Input causes derived
                  {{ streamRateConvention === 'l1-mbps' ? 'L1' : 'L2' }} bandwidth:
                  {{ derivedL1UdpBwB2A }} Mbps to exceed max configured bandwidth {{ maxBandWidth }}
                </mat-error>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="formField.streamType === 'Video'">
      <div class="section-label">
        <div>Video Settings</div>
        <div class="unit-label vert-text-mid">Select emulated video settings for this stream.</div>
      </div>
      <div class="section-data">
        <div class="group">
          <div class="label">Type</div>
          <mat-select
            class="option-list width-150"
            #videoTypeInput="ngModel"
            [(ngModel)]="formField.videoType"
            name="videoType"
            (selectionChange)="onVideoTypeChange()"
            required
          >
            <mat-option *ngFor="let item of videoTypeSelection" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Compression</div>
          <mat-select
            class="option-list width-150"
            #compressionTypeInput="ngModel"
            [(ngModel)]="formField.compression"
            name="compression"
            (selectionChange)="onCompressionChange()"
            required
          >
            <mat-option *ngFor="let item of compressionSelection" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Number of Channels</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="channels"
            #channelsInput="ngModel"
            [(ngModel)]="formField.channels"
            [min]="minChannels"
            [max]="maxChannels"
            (click)="onNumberOfChannelsChange()"
            (focusout)="onNumberOfChannelsChange()"
            required
          />
          <div
            class="error error-space clr-float"
            *ngIf="channelsInput.invalid && (channelsInput.dirty || channelsInput.touched)"
          >
            <mat-error *ngIf="channelsInput.errors?.required"> Field is required</mat-error>
            <mat-error *ngIf="channelsInput.errors?.min || channelsInput.errors?.max">
              Value should be {{ minChannels }} to {{ maxChannels }}</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="formField.streamType === 'Voice'">
      <div class="section-label">
        <div>VoIP Settings</div>
        <div class="unit-label vert-text-mid">Select emulated VoIP settings for this stream.</div>
      </div>
      <div class="section-data">
        <div class="group">
          <div class="label">Codec</div>
          <mat-select
            class="option-list width-150"
            #codecInput="ngModel"
            [(ngModel)]="formField.codec"
            name="codec"
            (selectionChange)="onCodecTypeChange()"
            required
          >
            <mat-option *ngFor="let item of codecSelection" [value]="item.value">{{
              item.id
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Sampling Rate</div>
          <mat-select
            class="option-list width-150"
            #samplingRateInput="ngModel"
            [(ngModel)]="formField.samplingRate"
            name="samplingRate"
            (selectionChange)="updateVoiceConfig()"
            required
          >
            <mat-option *ngFor="let item of samplingRateSelection" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Number of Calls</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="calls"
            #callsInput="ngModel"
            [(ngModel)]="formField.calls"
            [min]="minCalls"
            [max]="maxCalls"
            (click)="updateVoiceConfig()"
            (focusout)="updateVoiceConfig()"
            required
          />
          <div
            class="error error-space clr-float"
            *ngIf="callsInput.invalid && (callsInput.dirty || callsInput.touched)"
          >
            <mat-error *ngIf="callsInput.errors?.required"> Field is required</mat-error>
            <mat-error *ngIf="callsInput.errors?.min || callsInput.errors?.max">
              Value should be {{ minCalls }} to {{ maxCalls }}</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="section-container">
        <div class="section-label">
          <div>Packet Loss Ratio</div>
          <div class="unit-label vert-text-mid">Set Pakcet Loss Ratio Threshold</div>
        </div>
        <div class="section-data">
          <div class="group">
            <div class="label">Packet Loss Ratio</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-75 float-left"
              name="packetLossRatio"
              #packetLossRatioInput="ngModel"
              [(ngModel)]="formField.packetLossRatio"
              min="0"
              max="100"
              required
            />
            <span class="unit-label vert-text-mid">Packet Loss Ratio %</span>
            <div
              class="error error-space clr-float"
              *ngIf="
                packetLossRatioInput.invalid &&
                (packetLossRatioInput.dirty || packetLossRatioInput.touched)
              "
            >
              <mat-error *ngIf="packetLossRatioInput.errors?.required">
                Field is required</mat-error
              >
              <mat-error
                *ngIf="packetLossRatioInput.errors?.min || packetLossRatioInput.errors?.max"
              >
                Value should be 0 to 100</mat-error
              >
            </div>
          </div>
        </div>
      </div>
      <div class="section-container">
        <div class="section-label">
          <div>Layer 4</div>
          <div class="unit-label vert-text-mid">Set layer 4 test parameters.</div>
        </div>
        <div class="section-data">
          <div class="group">
            <div class="label">Port</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-75 float-left"
              name="portNumber"
              #portNumberInput="ngModel"
              [(ngModel)]="formField.portNumber"
              min="8080"
              max="8089"
              (focusout)="onPortNumberChange()"
              required
            />
            <span class="unit-label vert-text-mid">Port Number</span>
            <div
              class="error error-space clr-float"
              *ngIf="portNumberInput.invalid && (portNumberInput.dirty || portNumberInput.touched)"
            >
              <mat-error *ngIf="portNumberInput.errors?.required"> Field is required</mat-error>
              <mat-error *ngIf="portNumberInput.errors?.min || portNumberInput.errors?.max">
                Value should be 8080 to 8089</mat-error
              >
            </div>
            <mat-error *ngIf="isValidPortNumber && portNumberInput.valid" class="udp-port-error"
              >UDP port should be unique. {{ formField.portNumber }} is already used.</mat-error
            >
          </div>
        </div>
      </div>
      <div class="section-container">
        <div class="section-label">
          <div>Jitter Threshold</div>
          <div class="unit-label vert-text-mid">Set Jitter Threshold.</div>
        </div>
        <div class="section-data">
          <div class="group">
            <div class="label">Jitter Threshold</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-75 float-left"
              name="jitterThreshold"
              #jitterThresholdInput="ngModel"
              [(ngModel)]="formField.jitterThreshold"
              min="0"
              max="100"
              required
            />
            <span class="unit-label vert-text-mid">ms</span>
            <div
              class="error error-space clr-float"
              *ngIf="
                jitterThresholdInput.invalid &&
                (jitterThresholdInput.dirty || jitterThresholdInput.touched)
              "
            >
              <mat-error *ngIf="jitterThresholdInput.errors?.required">
                Field is required</mat-error
              >
              <mat-error
                *ngIf="jitterThresholdInput.errors?.min || jitterThresholdInput.errors?.max"
              >
                Value should be 0 to 100</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-group">
    <button
      mat-flat-button
      class="save-btn"
      [disabled]="
        !form.valid ||
        isL1ULRBandwidthMaxA2B ||
        isL1ULRBandwidthMaxB2A ||
        isL2IrA2B ||
        isL2IrB2A ||
        isValidPortNumber
      "
      (click)="onSaveStreamTypeSettingsData()"
    >
      SAVE
    </button>
    <button mat-button class="save-btn cancel" (click)="onClickCancel()">CANCEL</button>
  </div>
</form>
